import React, { useCallback } from 'react'
import styled from 'styled-components'
import { size } from 'styled-theme'
import { Flex } from '@rebass/grid'
import Text from '../../atoms/Text'
import AdSense from '../../atoms/AdSense'
import Viewport from '../../atoms/Viewport'
import ContentBox from '../../atoms/ContentBox'
import LoginForm from '../../molecules/LoginForm'
import AdSenseGroupView from '../../molecules/AdSenseGroupView'
import { useBuyMeACoffeeWidget } from '../../../services/buymeacoffee'
import { getErrorMessage } from '../../../utlils/form'
import { getStoredAuth } from '../../../api'
import { login, googleLogin } from '../../../api/auth'
import { useAuth } from '../../../contexts/auth'
import { useLoading } from '../../../contexts/loading'

const loginFormInitialValues = {
  username: '',
  password: '',
}

const StyledViewport = styled(Viewport)`
 padding: 8rem 2rem 3rem;
 align-items: flex-start;
  @media only screen and (max-width: ${size('mobile')}) {
    padding: 4rem 0 0;
  }
`

const StyledContentBox = styled(ContentBox)`
  @media only screen and (max-width: ${size('mobile')}) {
    padding-bottom: 6rem;
  }
`

const LoginPage = () => {
  const { setAuth } = useAuth()
  const { setLoading } = useLoading()

  useBuyMeACoffeeWidget()

  const onLogin = useCallback((values, { setFieldError }) => {
    setLoading(true)
    return login(values.username, values.password)
      .then(({ data: user }) => {
        const auth = getStoredAuth()
        const newAuth = { ...auth, user }
        setAuth(newAuth)
      })
      .catch((err) => {
        setFieldError('form', getErrorMessage(err))
      })
      .finally(() => {
        setLoading(false)
      })
  }, [setLoading, setAuth])

  const onGoogleLogin = useCallback((authData, { setFieldError }) => {
    setLoading(true)
    return googleLogin(authData)
      .then(({ data: user }) => {
        const auth = getStoredAuth()
        const newAuth = { ...auth, user }
        setAuth(newAuth)
      })
      .catch((err) => {
        setFieldError('form', getErrorMessage(err))
      })
      .finally(() => {
        setLoading(false)
      })
  }, [setAuth, setLoading])

  return (
    <StyledViewport>
      <StyledContentBox>
        <Flex justifyContent="center" mb="2rem">
          <Text palette="primary" bold variant="h1">歡迎回來！</Text>
        </Flex>
        <LoginForm
          onLogin={onLogin}
          onGoogleLogin={onGoogleLogin}
          initialValues={loginFormInitialValues}
          forgotPasswordPath="/forgot-password"
          registerPath="/register"
        />
        <AdSense
          adSlotId="9477289676"
          data-full-width-responsive="false"
          style={{ height: 120, width: '100%' }}
          containerProps={{ width: 1, height: 120, mt: '2rem' }}
        />
      </StyledContentBox>
      <AdSenseGroupView />
    </StyledViewport>
  )
}

export default LoginPage
